<template>
  <div class="pop" >
    <div :class="{'pop-mask':showPopDialog}"></div>
    <div class="pop-mark" >
      <div class="title-text" v-if="showTitleDialog" >
        <div class="text">
          <p class="p1">努力接住掉落的星星</p>
          <!-- <p class="p1">倒计时 3 2 1</p> -->
        </div>
      </div>
      <transition name="fade" @after-leave="afterLeave">
        <div v-show="showCountDownTime" class="pop-time-count">
        {{ countDownTime }}
        </div>
      </transition>
      <div v-if="showPopDialog" class="pop-dialog"  >
        <div class="pop-bg">
          <div class="empty"></div>
          <div class="pop-open" v-if="prizeStatus == '0'">
            <div class="title-1">
              <span class="span-1">恭喜您获得</span>
              <span class="span-2">{{firstCenter}}</span>
              <!-- <span class="span-1">积分</span> -->
            </div>
            <div class="title-2">
              <span class="span-3">(积分已充值至积分账户)</span>
            </div>
          </div>
          <div class="pop-open" v-if="prizeStatus == '1'">
            <div class="title-1">
              <span class="span-1">恭喜您获得</span>
              <span class="span-2">{{firstCenter}}</span>
              <span class="span-1">*1</span>
            </div>
            <div class="title-2">
              <span class="span-3">(卡劵已发放至易加账户卡包)</span>
            </div>
          </div>
          <div class="pop-open" v-if="prizeStatus == 2">
            <div class="title-1">
              <span class="span-1">很遗憾, 您未点击星星，本轮游戏</span>
            </div>
            <div class="title-2">
              <span class="span-1">未获得奖励，请再接再厉！</span>
            </div>
          </div>
          <!-- <div class="pop-open" v-if="prizeStatus == 3">
            <div class="title-1">
              <span class="span-1">抱歉，您未点击星星，本轮游戏</span>
            </div>
            <div class="title-2">
              <span class="span-1">未获得奖励，请再接再厉！</span>
            </div>
          </div> -->
          <div class="pickTimes">
            <span class="sapn-black">剩余</span>
            <span class="span-yellow">{{pickTimes}}</span>
            <span class="sapn-black">次机会</span>
          </div>
          <div class="pop-btn">
            <div class="left" @click="myPopcard" v-if="prizeStatus !== '0'"></div>
            <div class="left2" @click="myIntegral" v-if="prizeStatus == '0'"></div>
            <div class="right" @click="goHome"></div>
          </div>
        </div>
        <!-- <div class="pop-btn-close">
          <img @touchstart="handleClosePop" src="../../../assets/images/redPacketRain/mobile/btn-close.png"/>
        </div> -->
        <div class="button-pick" v-if="isShowkeep" @click="keepPick"></div>
        <div class="button-pick2" v-if="!isShowkeep" ></div>
      </div>
      <canvas id="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'

export default {
  name: 'RedPacketPop',
  props: {},
  watch: {
    // 红包雨倒计时结束
    'countDownTime' () {
      if (this.countDownTime === 0) {
        clearInterval(this.timerCountDown)
        this.initImages()
        this.showTitleDialog = false
      }
    }
  },
  created () {
    this.startCountDownTime()
  },
  beforeDestroy () {
    if (this.timerCountDown) {
      clearInterval(this.timerCountDown)
      clearTimeout(this.timerRain)
    }
  },
  data () {
    return {
      showCountDownTime: false,
      countDownTime: 3,
      pointsNum: 0,
      timerCountDown: '',
      ctx: '',
      imagesList: [],
      canvas: {
        width: '',
        height: ''
      },
      count: null,
      animationId: '',
      touchePos: '',
      timerRain: '',
      timerPushRedPacket: '',
      popOpen: {
        title: '',
        content: '',
        imgUrl: ''
      },
      showPopDialog: false,
      showCountDown: false,
      showPrizePop: false,
      showTitleDialog: true,
      prizeStatus: '',
      firstCenter: '',
      isShowkeep: false,
      pickTimes: '' // 剩余摘星次数
    }
  },
  methods: {
    // 下红包雨前倒计时 3s
    startCountDownTime () {
      this.showCountDownTime = true
      this.timerCountDown = setInterval(() => {
        this.showCountDownTime = !this.showCountDownTime
      }, 700)
    },
    // 淡入淡出效果结束调用
    afterLeave () {
      this.countDownTime--
    },
    initImages () {
      const RedPacketImg = new Image()
      RedPacketImg.src = require('../../../assets/images/activity/pickStar/star.png')
      RedPacketImg.onload = () => {
        this.initCanvas()
        this.timerPushRedPacket = setInterval(() => {
          this.imagesList.push(this.initImageItem(RedPacketImg))
          if (!this.count) {
            this.count = true
            this.drawImages()
          }
          // 200
        }, 1000)
        // 计时器红包雨持续时间10s
        this.timerRain = setTimeout(() => {
          this.stopRedPacketRain()
        }, 1000 * 60)
      }
    },
    // 初始化canvas 监听点击事件
    initCanvas () {
      const canvas = document.getElementById('canvas')
      canvas.addEventListener('touchstart', event => {
        this.touchePos = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY
        }
        this.handleClickRedPacket()
      })
      this.canvas.width = canvas.width = window.innerWidth
      this.canvas.height = canvas.height = window.innerHeight
      if (canvas.getContext) {
        this.ctx = canvas.getContext('2d')
      }
    },
    // 生成随机红包图片
    initImageItem (image) {
      return {
        image,
        x: parseInt(Math.random() * this.canvas.width - 50), // 图片右下角x坐标
        y: parseInt(Math.random() * -30), // 图片右下角y坐标
        // parseInt(Math.random() * 1 + 2)
        speed: parseInt(Math.random() * 1 + 1), // 下落速度
        // width: 151.3, // 图片宽度
        // height: 284.3 // 图片高度
        width: 113.5, // 1/4图片宽度
        height: 213.3 // 1/4图片高度
      }
    },
    // 绘制动画
    drawImages () {
      // 屏幕尺寸改变时重新初始化canvas
      if (this.canvas.width !== window.innerWidth || this.canvas.height !== window.innerHeight) {
        this.initCanvas()
      }
      // this.ctx.rotate(1/6*Math.PI);
      // this.ctx.rotate(120 * Math.PI / 180)
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.imagesList.forEach((item, index) => {
        this.ctx.drawImage(item.image, item.x -= item.speed, item.y += (item.speed + 1), item.width + 20, item.height)
        // 如果下落到超出canvas范围 则删除该红包
        if (item.y > this.canvas.height) {
          this.imagesList.splice(index, 1)
        }
      })
      this.animationId = window.requestAnimationFrame(this.drawImages)
    },
    handleClickRedPacket () {
      for (let i = 0; i < this.imagesList.length; i++) {
        const img = this.imagesList[i]
        // 红包图片x坐标范围
        const imgRangeX = {
          min: img.x,
          max: img.x + img.width
        }
        // 红包图片y坐标范围
        const imgRangeY = {
          min: img.y,
          max: img.y + img.height
        }
        const touchX = this.touchePos.x
        const touchY = this.touchePos.y
        // 判断点击的坐标是否落在红包图片坐标范围内
        if (touchX > imgRangeX.min && touchX < imgRangeX.max && touchY > imgRangeY.min && touchY < imgRangeY.max) {
          this.imagesList.splice(i, 1)
          this.pointsNum++
          this.pickStars()
          return
        }
      }
    },
    // 倒计时结束关闭红包雨
    stopRedPacketRain () {
      clearTimeout(this.timerRain)
      if (this.pointsNum === 0) {
        this.pickStars()
      }
      clearInterval(this.timerPushRedPacket)
      // window.cancelAnimationFrame(this.animationId)
      // this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      // 停止往数组添加红包
      // clearInterval(this.timerPushRedPacket)
      // // 关闭动画
      // window.cancelAnimationFrame(this.animationId)
      // // 清除画布
      // this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    // 点击星星
    pickStars () {
      let data = {}
      if (this.pointsNum > 0) {
        data = { isLottery: 1 }
        this.stopRedPacketRain()
      } else {
        data = { isLottery: 0 }
      }
      activityApi.goPickstar(data).then(res => {
        this.getPicktimes()
        if (res.data.resultCode === '0') {
          if (res.data.resultData) {
            this.prizeStatus = res.data.resultData.PrizeType
            this.firstCenter = res.data.resultData.lotteryPrize
            this.showPopDialog = true
          } else {
            this.prizeStatus = 2
            this.showPopDialog = true
          }
        }
      })
    },
    // 继续抽奖
    keepPick () {
      this.pointsNum = 0
      this.prizeStatus = ''
      this.showPopDialog = false
      this.initImages()
    },
    getPicktimes () {
      activityApi.getActivitystar().then(res => {
        if (res.data.resultCode === '0') {
          let data = res.data.resultData
          this.pickTimes = data.availableLotteryCount
          if (this.pickTimes > 0) {
            this.isShowkeep = true
          } else {
            this.pickTimes = 0
            this.isShowkeep = false
          }
        }
      })
    },
    myPopcard () {
      this.showPopDialog = false
      this.$emit('goMycard')
    },
    myIntegral () {
      this.showPopDialog = false
      this.$emit('goMyintegral')
    },
    goHome () {
      window.cancelAnimationFrame(this.animationId)
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.showPopDialog = false
      this.$emit('closePickStar')
    },
    handleClosePop () {
      this.showPopDialog = false
      this.$emit('closePickStar')
    }
  }
}
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.pop-mask{
  position: fixed ;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,.5) ;
  z-index: 4;
}
.pop {
  .pop-mark {
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    background: url(../../../assets/images/activity/pickStar/pickStar-bj-game.png) no-repeat;
    background-size: 100% 100%;
    width:100%;
    height: 100%;
    overflow-y:hidden;
    // height: 100vh;
    .title-text{
      // padding: calc(15vh) calc(10vw) 0 calc(10vw);
      margin-top: 180px;
      z-index: 5;
      .text {
        width: 70%;
        // height: 145px;
        margin-left: 15%;
        font-size: 20px;
        color: #000000;
        border-radius: 10px;
        // background-color: rgba(255, 255, 255,.7);
        background: url(../../../assets/images/activity/pickStar/game-bj.png) no-repeat;
        opacity: 0.8;
        background-size: 100%;
        // border: 1px solid #cd1231;
        .p1 {
          text-align: center;
          height: 100px;
          line-height: 100px;
          font-family: SourceHanSansSC-medium;
        }
      }
    }
    .pop-time-count {
      line-height: calc(100vh);
      // font-size: 180px;
      // font-weight: 600;
      font-size: 30px;
      font-weight: 600;
      color:#f0f0f0;
    }
    .pop-dialog {
      // padding: calc(20vh) calc(10vw) 0 calc(10vw);
      width: 326.7px;
      height: 323px;
      position: absolute;
      top: 180px;
      left: 24px;
      z-index: 5;

      .pop-bg {
        z-index: 5;
        width: 326.7px;
        height: 231px;
        // margin-bottom: 20px;
        text-align: center;
        background: url("../../../assets/images/activity/pickStar/pickStar-bj-open.png") no-repeat;
        background-size: 100% 100%;
        .empty{
        width: 326.7px;
        height: 25px;
        }
        .pop-open{
          width: 326.7px;
          height: 90px;
          line-height: 90px;
          text-align: center;
          // margin-bottom: 10px;
          .title-1{
            display: flex;
            justify-content: center;
            width: 326.7px;
            height: 20px;
            margin-bottom: 5px;
            // line-height: 20px;
            // margin-top: 20px;
            .span-1{
              font-size: 16px;
              font-weight: 600;
            }
            .span-2{
              font-size: 18px;
              font-weight: 600;
              color: rgba(17, 113, 129);
              margin: 0 5px;
            }
          }
          .title-2{
            width: 326.7px;
            height: 20px;
            .span-3{
            font-size: 12px;
            font-weight:bold;
            }
            .span-1{
            font-size: 16px;
            font-weight: 600;
            }

          }
        }
        .pickTimes{
          width: 100%;
          height: 35px;
          line-height: 35px;
          text-align: center;
          .sapn-black{
            font-size: 16px;
            font-weight: 600;
          }
          .span-yellow{
            font-size: 18px;
            font-weight: 600;
            color: rgba(239, 232, 108);
            margin: 0 5px;
          }
        }
        .pop-btn{
          width: 326.7px;
          height: 70px;
          line-height: 70px;
          display: flex;
          justify-content:center ;
          .left{
            width: 133.3px;
            height: 30px;
            margin-top: 20px;
            background: url("../../../assets/images/activity/pickStar/pickStar-btn-mycard.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 6px;
          }
          .left2{
            width: 133.3px;
            height: 30px;
            margin-top: 20px;
            background: url("../../../assets/images/activity/pickStar/pickStar-btn-myintegral.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 6px;
          }
          .right{
            width: 133.3px;
            height: 30px;
            margin-top: 20px;
            background: url("../../../assets/images/activity/pickStar/pickStar-btn-goback.png") no-repeat;
            background-size: 100% 100%;
            margin-left: 6px;
          }

        }

      }
    }
    .button-pick{
      z-index: 5;
      width: 216.7px;
      height: 48.7px;
      line-height: 48.7px;
      text-align: center;
      margin: 0 auto;
      margin-top: 30px;
      background: url("../../../assets/images/activity/pickStar/keep-on-pick.png") no-repeat;
      background-size: 100% auto;
    }
    .button-pick2{
      z-index: 5;
      width: 216.7px;
      height: 48.7px;
      line-height: 48.7px;
      text-align: center;
      margin: 0 auto;
      margin-top: 30px;
      background: url("../../../assets/images/activity/pickStar/keep-on-pick-black.png") no-repeat;
      background-size: 100% auto;
    }
    // .pop-btn-close {
    //   z-index: 5;
    //   text-align: center;
    //   img {
    //     max-width: 40px;
    //     // background: url(../../../assets/images/redPacketRain/mobile/btn-close.png) no-repeat;
    //   }
    // }
  }
}
</style>
